export const id = (...ids: (number | null | undefined)[]): string | null => {
    if(ids.some(x => x === undefined || x === null)) {
        return null;
    }
    return ids.length > 1 ? ids.join("-") : `${ids[0]}`;
} 